import ja from './ja'
import en from './en'

export const messages = {
  ja,
  en,
}
